export default __webpack_public_path__ + "static/media/doctors.378bb27c.jpg";